import { Constants } from '../../../common/constants';
import { billingPlanType, clinicUserType, paymentType } from '../../../common/constants/Constants';
export const getBillingPlanTypeLabel = (type) => {
    let label = '';
    switch (type) {
        case Constants.billingPlanType.standard:
            label = 'お手軽';
            break;
        case Constants.billingPlanType.performanceReward:
            label = '成果報酬';
            break;
        case Constants.billingPlanType.professional:
            label = '使い放題';
            break;
        default:
            label = 'フリープラン';
            break;
    }
    return label;
};
export const isUnregisteredUser = (paymentClinic) => {
    var _a, _b;
    return ((_a = paymentClinic) === null || _a === void 0 ? void 0 : _a.clinicUserType) !== clinicUserType.vip && ((_b = paymentClinic) === null || _b === void 0 ? void 0 : _b.planType) === billingPlanType.free;
};
// 支払い方法が現金支払いか確認
export const isPaymentCash = (payment) => {
    return payment === paymentType.paymentCache;
};
// 支払い方法リストが銀行振込を含んでいるか
export const hasPaymentBankTransfer = (paymentList) => {
    return paymentList.some((val) => val === paymentType.paymentBankTransfer);
};
// [利用プラン]契約更新日時を持つプランかどうか
export const isPlanHaveRenewalDate = (planType) => {
    return planType === billingPlanType.standard || planType === billingPlanType.professional;
};
